import {ElasticSearchConfig, ElasticSearchKnnSearchResponse} from "@me8eon/ai.tools.utils";
import { EnvironmentConfig } from "@me8eon/config";
import { JwtTokenFn } from "@me8eon/authentication";

export const fetchOrderItElasticSearchWithDeviceTypeFilter = async (esConfig: ElasticSearchConfig, indices: string[], deviceType: string, jwtTokenFn: JwtTokenFn) => {

    const {
        axios,
    } = esConfig;

    const indiciesAsString = indices.join(",");
    const url = `${EnvironmentConfig.elasticSearchProxyUrl}/${indiciesAsString}/_search`;
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await jwtTokenFn()}`,
    };

    const body = {
        "_source": {
            "excludes": [
                "denied_countries",
                "denied_companies",
                "denied_users",
                "allowed_countries",
                "allowed_companies",
                "allowed_users",
                "allowed_all_countries",
                "allowed_all_companies",
                "allowed_all_users",
                "dense_vector",
                "sparse_vector",
                "semantic_text"
            ]
        },
        "size": 30,
        "query": {
            "bool": {
                "must": [
                    {"term": {"device_type.keyword": deviceType}},
                ],
                "must_not": [
                    {"term": {"price.keyword": "0"}}
                ]
            }
        }
    }


    return axios.post<ElasticSearchKnnSearchResponse>(url, body, {headers: headers});
}